module.exports = __webpack_public_path__ + "static/media/280944.96502447.png";